
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Add enhanced error handling for rendering
const rootElement = document.getElementById("root");

if (rootElement) {
  try {
    console.log("Initializing application...");
    const root = createRoot(rootElement);
    console.log("Root created, rendering App component...");
    root.render(<App />);
    console.log("App rendered successfully");
  } catch (error) {
    console.error("Error rendering the application:", error);
    // Display a fallback UI if rendering fails
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h1>Something went wrong</h1>
        <p>The application could not be loaded. Please try again later.</p>
        <pre style="text-align: left; background: #f5f5f5; padding: 10px; border-radius: 4px;">${error instanceof Error ? error.message : 'Unknown error'}</pre>
      </div>
    `;
  }
} else {
  console.error("Root element not found");
}
